import {gzip} from 'pako';

// pako replaces gzip-js (denylisted in NpmPrettyMuch); both emit standard RFC-1952 gzip.
export const compress = (input_text: string) => {
    return gzip(input_text, {level: 6});
};
